import { withTranslations } from '@/utils/Language';
import uiEn from '@/assets/i18n/ui/en.json';
import mainEn from '@/assets/i18n/main/en.json';
import modalsEn from '@/assets/i18n/modals/en.json';
import tagsEn from '@/assets/i18n/tags/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...uiEn, ...mainEn, ...modalsEn, ...tagsEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/ui/${lang}.json`),
      import(`@/assets/i18n/main/${lang}.json`),
      import(`@/assets/i18n/modals/${lang}.json`),
      import(`@/assets/i18n/tags/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([ui, main, modals, tags, languages, languagesTranslated]) => ({
      ...ui.default,
      ...main.default,
      ...modals.default,
      ...tags.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
